export default __webpack_public_path__ + "static/media/apple-store-badge@2x.b171e22e.png";